import { useState } from 'react';

const articles = [
  {
    id: '001',
    kicker: '브랜드 전략',
    headline: '럭셔리 뷰티 LUMIÈRE, 리런칭 6개월 만에 인지도 3배 껑충',
    summary: 'caratings의 통합 브랜드 전략으로 LUMIÈRE는 6개월 내 브랜드 인지도 240% 상승을 기록했다. 시장 포지셔닝 재설계와 크리에이티브 리뉴얼이 핵심이었다.',
    result: '브랜드 인지도 +240%',
    client: 'LUMIÈRE',
    date: '2024.03',
    featured: true,
  },
  {
    id: '002',
    kicker: 'SNS 마케팅',
    headline: 'MODO FASHION, 8개월 만에 인스타그램 12만 팔로워 달성',
    summary: '0부터 시작한 계정이 전략적 콘텐츠 운영으로 급성장. 알고리즘 분석 기반 콘텐츠 캘린더가 주효했다.',
    result: '팔로워 120,000 달성',
    client: 'MODO FASHION',
    date: '2023.11',
    featured: false,
  },
  {
    id: '003',
    kicker: '퍼포먼스 광고',
    headline: 'HOMESTYLE 광고 효율 3.4배 개선… ROAS 1.8에서 6.2로',
    summary: '실시간 입찰 최적화와 오디언스 세그멘테이션으로 광고비 절감과 매출 동시 상승을 달성했다.',
    result: 'ROAS 1.8× → 6.2×',
    client: 'HOMESTYLE',
    date: '2023.08',
    featured: false,
  },
  {
    id: '004',
    kicker: '브랜드 전략',
    headline: 'GREENLEAP, 브랜드 재설계 후 시리즈A 80억 투자 유치 성공',
    summary: '스타트업 초기 단계부터 투자자 관점의 브랜딩을 설계해 VC로부터 높은 평가를 받았다.',
    result: '시리즈A 80억 유치',
    client: 'GREENLEAP',
    date: '2022.06',
    featured: false,
  },
];

export default function Portfolio() {
  const [hov, setHov] = useState(null);
  const featured = articles[0];
  const rest = articles.slice(1);

  return (
    <section id="portfolio" className="py-16 border-b-4 border-ink bg-cream">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section header */}
        <div className="flex items-center gap-4 mb-2">
          <div className="bg-red text-paper font-sans text-xs font-black tracking-widest px-3 py-1.5 uppercase">
            단독
          </div>
          <div className="border-t border-rule-2 flex-1" />
          <span className="font-mono text-xs text-dim">CASE FILES · PORTFOLIO</span>
        </div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 border border-rule-2">
          {/* Featured article */}
          <div className="lg:col-span-7 border-b lg:border-b-0 lg:border-r border-rule-2 p-7 cursor-default group"
            onMouseEnter={() => setHov('feat')}
            onMouseLeave={() => setHov(null)}
            style={{ background: hov==='feat' ? '#EDE9E1' : 'transparent' }}>
            <p className="font-sans text-xs font-bold tracking-[0.2em] uppercase text-red mb-2">{featured.kicker} · {featured.date}</p>
            <div className="w-full border-t-2 border-ink mb-4" />
            <h3 className="font-headline font-black text-ink leading-tight mb-4 group-hover:text-red transition-colors duration-200"
              style={{ fontSize: 'clamp(22px, 2.5vw, 36px)' }}>
              {featured.headline}
            </h3>
            {/* Fake image placeholder */}
            <div className="w-full h-44 mb-4 flex items-center justify-center"
              style={{ background: '#1A1818' }}>
              <span className="font-headline font-black text-4xl text-red">{featured.client}</span>
            </div>
            <p className="font-serif text-base leading-relaxed text-dim mb-5">{featured.summary}</p>
            <div className="flex items-center justify-between border-t border-rule-2 pt-4">
              <span className="font-sans text-xs text-dim">CLIENT: {featured.client}</span>
              <span className="font-sans font-bold text-sm text-red">{featured.result}</span>
            </div>
          </div>

          {/* Sidebar articles */}
          <div className="lg:col-span-5">
            {rest.map((a, i) => (
              <div key={a.id}
                className="p-5 border-b border-rule-2 last:border-b-0 cursor-default group transition-colors duration-200"
                style={{ background: hov===a.id ? '#EDE9E1' : 'transparent' }}
                onMouseEnter={() => setHov(a.id)}
                onMouseLeave={() => setHov(null)}>
                <div className="flex items-center justify-between mb-2">
                  <p className="font-sans text-xs font-bold tracking-[0.2em] uppercase text-red">{a.kicker}</p>
                  <span className="font-mono text-xs text-dim">{a.date}</span>
                </div>
                <h4 className="font-headline font-bold text-base text-ink leading-snug mb-2 group-hover:text-red transition-colors duration-200">
                  {a.headline}
                </h4>
                <p className="font-serif text-sm text-dim leading-relaxed mb-3 line-clamp-2">{a.summary}</p>
                <div className="flex items-center justify-between">
                  <span className="font-sans text-xs text-dim">{a.client}</span>
                  <span className="font-mono text-xs text-red font-bold">{a.result}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
